import { render, staticRenderFns } from "./HomeTopicHighlights.vue?vue&type=template&id=1220f15a&scoped=true"
import script from "./HomeTopicHighlights.vue?vue&type=script&lang=js"
export * from "./HomeTopicHighlights.vue?vue&type=script&lang=js"
import style0 from "./HomeTopicHighlights.vue?vue&type=style&index=0&id=1220f15a&prod&scoped=true&lang=css"
import style1 from "./HomeTopicHighlights.vue?vue&type=style&index=1&id=1220f15a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1220f15a",
  null
  
)

export default component.exports